import "./class.css"

const Class = () => {
    return (
        <div className="class">
            zenith is here with the others zenith will not stop ontill the rejection comes to an end with the main guy though
            cause man's already international cause that's the 
            Zenith talking now with all the ResponsiveContainer
        </div>
    )
}

export default Class
